import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtro',
  standalone: false
})
export class FiltroPipe implements PipeTransform {

  transform(itens: any[], termoPesquisado: any, nomeDaColuna: string): any[] {
    if(!itens)  return [];
    if(!termoPesquisado)  return itens;

    termoPesquisado = termoPesquisado.toLocaleLowerCase();

    return itens.filter(item => {
        const valor = item[nomeDaColuna];
        if(valor === null || valor === undefined)  return false;
        return valor.toString().toLowerCase().includes(termoPesquisado);
    });
  }

}
